import React, { useState } from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { DangerIcon, ExtensionIcon, FlagIcon, Heart2Icon, MilitaryTechIcon, NonAcademicIcon, PersonCheckIcon, ThumbUpIcon } from "../assets/icons";
import { SectionHeading } from "./ReportCategoryShared";
import ReportGoodNewsCarousel from "./ReportGoodNewsCarousel";
import ReportModalSheet from "./ReportModalSheet";

const activities = [
  { name: "Project Fair Sem1", count: 9, score: 92 },
  { name: "Grow with Movement", count: 6, score: 88 },
  { name: "Seni Rupa", count: 6, score: 72 },
];
const parameters = [
  { label: "Parameter yang sudah baik", count: 34, total: 43, percentage: 87, color: "#48B920" },
  { label: "Parameter yang perlu ditingkatkan", count: 2, total: 43, percentage: 13, color: "#CB494B" },
];
const materials = {
  positive: [
    { category: "SIB", label: "B", name: "Self Awareness" },
    { category: "Grow with Movement", label: "CB", name: "Terbiasa berdoa (awal dan akhir)" },
    { category: "ISSI", label: "CB", name: "Kepekaan terhadap lingkungan" },
  ],
  attention: [
    { category: "SIB", label: "Perlu Perhatian", name: "Mengenali dan mengungkapkan perasaan dengan tepat." },
    { category: "Grow with Movement", label: "Perlu Perhatian", name: "Mengikuti kegiatan gerak bersama secara konsisten." },
    { category: "Seni Rupa", label: "Perlu Perhatian", name: "Menyelesaikan karya dengan mandiri." },
  ],
};
const news = {
  positive: [{ name: "menghormati guru dan teman: mendengarkan saat orang lain berbicara." }],
  attention: [materials.attention[0]],
};

function ActivityRow({ item }) {
  return (
    <View style={styles.activityRow}>
      <View style={styles.copy}>
        <Text style={styles.activityName}>{item.name}</Text>
        <Text style={styles.muted}>{item.count} Parameter</Text>
      </View>
      <View style={styles.scoreColumn}>
        <Text style={styles.score}>{item.score}%</Text>
        <View style={styles.track}><View style={[styles.fill, { width: `${item.score}%` }]} /></View>
      </View>
    </View>
  );
}

export default function ReportNonAcademicContent({ reportId, period, mode }) {
  const navigation = useNavigation();
  const [activitiesOpen, setActivitiesOpen] = useState(false);
  const [materialMode, setMaterialMode] = useState("positive");
  const attention = materialMode === "attention";
  const openIndicators = () => {
    const groups = [...materials.positive, ...materials.attention].reduce((result, item) => {
      const group = result.find((entry) => entry.name === item.category);
      if (group) group.indicators.push(item);
      else result.push({ name: item.category, indicators: [item] });
      return result;
    }, []);
    navigation.navigate("ReportIndicatorDetail", {
      id: reportId, mode, period, reportType: "materials", indicatorGroups: groups, showAllIndicators: true,
    });
  };

  return (
    <View style={styles.content}>
      <View style={styles.card}>
        <SectionHeading Icon={NonAcademicIcon} title="Pencapaian Non Akademik" actionLabel="Lihat Semua" onAction={openIndicators} />
        <View style={styles.metrics}>
          <View style={styles.metric}>
            <View style={styles.metricIcon}><PersonCheckIcon width={24} height={24} customColor="#5423B5" /></View>
            <View style={styles.copy}><Text style={styles.metricLabel}>Kegiatan</Text><Text style={styles.metricValue}>14</Text></View>
          </View>
          <View style={styles.metric}>
            <View style={styles.metricIcon}><MilitaryTechIcon customColor="#5423B5" /></View>
            <View style={styles.copy}><Text style={styles.metricLabel}>Pencapaian</Text><Text style={styles.metricValue}>84,51%</Text></View>
          </View>
        </View>
        <View style={styles.divider} />
        <View style={styles.parameterColumns}>
          {parameters.map((item) => (
            <View key={item.label} style={styles.copy}>
              <View style={styles.parameterTrack}><View style={[styles.parameterFill, { width: `${item.percentage}%`, backgroundColor: item.color }]} /></View>
              <Text style={styles.parameterLabel}>{item.label}</Text>
              <Text style={styles.parameterValue}>{item.count} dari {item.total}<Text style={styles.parameterPercentage}> • {item.percentage}%</Text></Text>
            </View>
          ))}
        </View>
      </View>

      <ReportGoodNewsCarousel indicatorData={news} />

      <View style={styles.card}>
        <SectionHeading Icon={Heart2Icon} title="TOP 3 Pelajaran Terbaik" actionLabel="Lihat Semua" onAction={() => setActivitiesOpen(true)} />
        <View style={styles.divider} />
        {activities.map((item) => <ActivityRow key={item.name} item={item} />)}
      </View>

      <View style={styles.card}>
        <SectionHeading Icon={ExtensionIcon} title="TOP 3 Materi" actionLabel="Lihat Semua" onAction={openIndicators} />
        <View style={styles.segments}>
          <Pressable accessibilityRole="button" accessibilityState={{ selected: !attention }} onPress={() => setMaterialMode("positive")} style={[styles.segment, !attention && styles.positiveBorder]}>
            <ThumbUpIcon width={22} height={22} customColor={!attention ? "#48B920" : "#151515"} />
            <Text style={[styles.segmentText, !attention && styles.positiveText]}>Materi{"\n"}Terbaik</Text>
            {!attention && <View style={[styles.underline, styles.green]} />}
          </Pressable>
          <Pressable accessibilityRole="button" accessibilityState={{ selected: attention }} onPress={() => setMaterialMode("attention")} style={[styles.segment, attention && styles.attentionBorder]}>
            <DangerIcon width={22} height={22} fill={attention ? "#D84343" : "#151515"} />
            <Text style={[styles.segmentText, attention && styles.attentionText]}>Perlu{"\n"}Perhatian</Text>
            {attention && <View style={[styles.underline, styles.red]} />}
          </Pressable>
        </View>
        {materials[materialMode].map((item, index, items) => (
          <View key={item.category} style={[styles.materialRow, index === items.length - 1 && styles.lastRow]}>
            <View style={styles.chips}>
              <View style={styles.categoryChip}><Heart2Icon customColor="#999999" /><Text style={styles.chipText}>{item.category}</Text></View>
              <View style={[styles.statusChip, attention && styles.attentionChip]}><FlagIcon width={13} height={13} customColor={attention ? "#D84343" : "#48B920"} /><Text style={[styles.statusText, attention && styles.attentionText]}>{item.label}</Text></View>
            </View>
            <Text style={styles.description}>{item.name}</Text>
          </View>
        ))}
      </View>

      <ReportModalSheet
        visible={activitiesOpen}
        onClose={() => setActivitiesOpen(false)}
        Icon={Heart2Icon}
        title="Kegiatan Terbaik"
      >
        <ScrollView style={styles.sheetList}>{activities.map((item) => <ActivityRow key={item.name} item={item} />)}</ScrollView>
      </ReportModalSheet>
    </View>
  );
}

const styles = StyleSheet.create({
  content: { gap: 16 },
  card: { padding: 14, borderRadius: 16, backgroundColor: "#FFFFFF", elevation: 2, shadowColor: "#34234A", shadowOpacity: 0.08, shadowRadius: 4, shadowOffset: { width: 0, height: 2 } },
  copy: { flex: 1, minWidth: 0 },
  metrics: { flexDirection: "row", gap: 16, paddingTop: 14, paddingBottom: 4 },
  metric: { flex: 1, flexDirection: "row", alignItems: "center", gap: 10 },
  metricIcon: { width: 44, height: 44, borderRadius: 10, backgroundColor: "#F0E9FF", alignItems: "center", justifyContent: "center" },
  metricLabel: { color: "#171717", fontFamily: "Archivo-Regular", fontSize: 12 },
  metricValue: { color: "#111111", fontFamily: "Archivo-Bold", fontSize: 16, marginTop: 3 },
  divider: { height: 1, backgroundColor: "#EEEEEE", marginVertical: 10 },
  parameterColumns: { flexDirection: "row", gap: 24, paddingTop: 4, paddingBottom: 4 },
  parameterTrack: { height: 12, borderRadius: 4, backgroundColor: "#F1F1F1", overflow: "hidden" },
  parameterFill: { height: "100%", borderRadius: 4 },
  parameterLabel: { minHeight: 36, marginTop: 14, color: "#171717", fontFamily: "Archivo-Regular", fontSize: 12, lineHeight: 16 },
  parameterValue: { marginTop: 8, color: "#111111", fontFamily: "Archivo-Bold", fontSize: 16 },
  parameterPercentage: { color: "#999999", fontFamily: "Archivo-Regular", fontSize: 14 },
  activityRow: { minHeight: 48, flexDirection: "row", alignItems: "center", gap: 12 },
  activityName: { color: "#5423B5", fontFamily: "Archivo-Bold", fontSize: 12 },
  muted: { color: "#999999", fontFamily: "Archivo-Regular", fontSize: 11, marginTop: 2 },
  scoreColumn: { width: "32%", alignItems: "flex-end", gap: 2 },
  score: { color: "#48B920", fontFamily: "Archivo-Bold", fontSize: 11 },
  track: { height: 11, width: "100%", backgroundColor: "#EAEAEA", borderRadius: 5, overflow: "hidden" },
  fill: { height: "100%", backgroundColor: "#48B920", borderRadius: 5 },
  segments: { flexDirection: "row", gap: 8, marginTop: 12, marginBottom: 4 },
  segment: { position: "relative", flex: 1, minHeight: 52, borderRadius: 8, borderWidth: 1, borderColor: "#E7E7E7", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 8, paddingHorizontal: 8 },
  segmentText: { color: "#171717", fontFamily: "Archivo-Regular", fontSize: 11, lineHeight: 14 },
  positiveBorder: { borderColor: "#48B920" },
  attentionBorder: { borderColor: "#D84343" },
  positiveText: { color: "#48B920" },
  attentionText: { color: "#D84343" },
  underline: { position: "absolute", bottom: 1, left: 16, right: 16, height: 4, borderRadius: 3 },
  green: { backgroundColor: "#48B920" },
  red: { backgroundColor: "#D84343" },
  materialRow: { paddingVertical: 10, borderBottomWidth: StyleSheet.hairlineWidth, borderColor: "#EEEEEE", borderStyle: "dashed" },
  lastRow: { borderBottomWidth: 0 },
  chips: { flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: 8 },
  categoryChip: { minHeight: 24, paddingHorizontal: 8, borderRadius: 5, backgroundColor: "#F1F1F1", flexDirection: "row", alignItems: "center", gap: 5 },
  chipText: { color: "#555555", fontFamily: "Archivo-Regular", fontSize: 9 },
  statusChip: { minHeight: 24, paddingHorizontal: 8, borderRadius: 5, backgroundColor: "#DDF3D5", flexDirection: "row", alignItems: "center", gap: 5 },
  attentionChip: { backgroundColor: "#FFE0E0" },
  statusText: { color: "#48B920", fontFamily: "Archivo-Regular", fontSize: 10 },
  description: { marginTop: 8, color: "#171717", fontFamily: "Archivo-Regular", fontSize: 11, lineHeight: 16 },
  sheetList: { maxHeight: 320, marginTop: 12 },
});